import { z } from 'zod';
import { BillingIntervalSchema } from '../types/subscriptions/enums';
import { BillingSchedulePreviewSchema } from './billing-schedule';
import { IsoTimestampSchema, Sha256HexSchema, StripeAccountIdSchema, StripePublishableKeySchema, } from './primitives';
/** A signup-local collection grant. No CustomerSession or saved-method access. */
const presentation = {
    provider: z.literal('STRIPE'),
    presentation: z.literal('FRESH_CARD'),
    publishableKey: StripePublishableKeySchema,
    connectedAccountId: StripeAccountIdSchema,
    sessionExpiresAt: IsoTimestampSchema,
    amountCents: z.number().int().nonnegative().safe(),
    currency: z.literal('USD'),
    recurring: z
        .object({
        amountCents: z.number().int().positive().safe(),
        interval: BillingIntervalSchema,
        intervalCount: z.number().int().min(1).max(52),
    })
        .strict(),
    billingPreview: BillingSchedulePreviewSchema.optional(),
};
export const FreshCardPaymentPresentationSchema = z.discriminatedUnion('stage', [
    z
        .object({
        ...presentation,
        stage: z.literal('SETUP'),
        clientSecret: z
            .string()
            .regex(/^seti_[A-Za-z0-9]+_secret_[A-Za-z0-9]+$/),
    })
        .strict(),
    z
        .object({
        ...presentation,
        stage: z.literal('PAYMENT'),
        clientSecret: z.string().regex(/^pi_[A-Za-z0-9]+_secret_[A-Za-z0-9]+$/),
        paymentMethodId: z.string().regex(/^pm_[A-Za-z0-9]+$/),
    })
        .strict(),
]);
/** Frozen only on newly accepted signups; absent means the original Session flow. */
export const FreshCardCheckoutStateSchema = z
    .object({
    version: z.literal(1),
    environment: z.string().min(1).max(64),
    expiresAt: IsoTimestampSchema,
    customerReference: Sha256HexSchema.optional(),
    setupIntentId: z
        .string()
        .regex(/^seti_[A-Za-z0-9]+$/)
        .optional(),
    setupClientSecret: z
        .string()
        .regex(/^seti_[A-Za-z0-9]+_secret_[A-Za-z0-9]+$/)
        .optional(),
    paymentMethodId: z
        .string()
        .regex(/^pm_[A-Za-z0-9]+$/)
        .optional(),
    paymentClientSecret: z
        .string()
        .regex(/^pi_[A-Za-z0-9]+_secret_[A-Za-z0-9]+$/)
        .optional(),
})
    .strict();
